import mixins from 'vue-typed-mixins';

import { Eフェーズ種別 } from '@/openapi/enum';

import C償却List from '@/entries/user/pages/authorized/事業所/計画書/分析計画/償却/components/償却List/償却List.vue';
import C償却EditRow from '@/entries/user/pages/authorized/事業所/計画書/分析計画/償却/components/償却EditRow/償却EditRow.vue';
import C減価償却Total from '@/entries/user/pages/authorized/事業所/計画書/分析計画/償却/components/減価償却Total/減価償却Total.vue';
import MoneyUnitSelect from '@/components/moneyUnitSelect/MoneyUnitSelect.vue';

import RoutesMixin from '@/entries/user/mixins/RoutesMixin';
import 償却EditableListMixin from '@/entries/user/mixins/償却EditableListMixin';

export default mixins(RoutesMixin, 償却EditableListMixin).extend({
  name: 'P設備投資',

  components: {
    C償却List,
    C償却EditRow,
    C減価償却Total,
    MoneyUnitSelect,
  },

  async created(): Promise<void> {
    // 初期設定
    this.initialize償却Service(Eフェーズ種別.計画フェーズ, '設備投資');
  },

  computed: {
    blankRowspan(): number {
      return (this.v償却?.total.設備投資?.科目別集計.取得価額s.length ?? 0) + 1;
    },
  },
});
